<script lang="ts">
    import CrinkledSection from "../lib/components/CrinkledSection.svelte"
    import ProductPageDesktop from "../lib/components/pagebuilder/product/ProductPageDesktop.svelte"
    import { getProductByHandle } from "../lib/functions/CommerceAPIs/bigCommerce/product"
    import { NotFoundError } from "../lib/functions/errors"

    export let handle = ""
    let product: BKDFProduct

    async function setProduct() {
        product = await getProductByHandle(handle)
        if (!product) NotFoundError("Produkt")
    }
    setProduct()
</script>

<div class="sticky-bar">
    <div class="bar"></div>
    <CrinkledSection />
</div>
{#if product}
    <ProductPageDesktop product="{product}" />
{:else}
    <p>Loading...</p>
{/if}

<style lang="less">
    .sticky-bar {
        top: 86px;
        width: 100%;
        position: sticky;
        z-index: 1000;

        .bar {
            background-color: #0d0c0c;
            width: 100%;
            height: 3rem;
        }
    }
</style>
